export const handleError = (error: any): void => {
  console.error('API Error:', error);
  // Ajoutez ici une gestion des erreurs plus sophistiquée si nécessaire
};
